<template>
  <div class="form-container container">
    <el-form label-width="250px">
      <el-alert
        :title="student.Status"
        type="warning"
        :closable="false"
        show-icon>
      </el-alert>

      <el-divider content-position="left">学生基本信息</el-divider>
    
      <el-card class="box-card">
        <el-form-item label="入读时间：">
          {{student.InTime}}
        </el-form-item>
        <el-form-item label="姓名：">
          {{student.StudentName}}
        </el-form-item>
        <el-form-item label="性别：">
          {{student.Sex}}
        </el-form-item>
        <el-form-item label="出生日期：">
          {{student.Birthday}}
        </el-form-item>
        <el-form-item label="身份证号码：">
          {{student.IDCard}}
        </el-form-item>
      </el-card>

      <el-divider content-position="left">父亲（第一监护人）信息</el-divider>
      <el-card class="box-card">
        <el-form-item label="姓名：">
          {{student.FatherName}}
        </el-form-item>
        <el-form-item label="学历：">
          {{student.FatherEducation}}
        </el-form-item>
        <el-form-item label="工作单位：">
          {{student.FatherUnit}}
        </el-form-item>
        <el-form-item label="联系电话：">
          {{student.FatherMobile}}
        </el-form-item>
      </el-card>

      <el-divider content-position="left">母亲（第二监护人）信息</el-divider>
      <el-card class="box-card">
        <el-form-item label="姓名：">
          {{student.MatherName}}
        </el-form-item>
        <el-form-item label="学历：">
          {{student.MatherEducation}}
        </el-form-item>
        <el-form-item label="工作单位：">
          {{student.MatherUnit}}
        </el-form-item>
        <el-form-item label="联系电话：">
          {{student.MatherMobile}}
        </el-form-item>
      </el-card>

      <el-divider content-position="left">其它信息</el-divider>
      <el-card class="box-card">
        <el-form-item label="是否在本园就读亲子班">
          {{student.IsParentingClass}}
        </el-form-item>
        <el-form-item label="是否有亲兄弟姐妹就读本园或美小">
          {{student.IsInSchool}}
        </el-form-item>
        <el-form-item label="父母是否美的员工">
          {{student.IsEmployee}}
        </el-form-item>
        <el-form-item label="家庭地址">
          【{{student.Town}}】{{student.Address}}
        </el-form-item>
        <el-form-item label="备注">
          {{student.Remark}}
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      student: this.data
    }
  },
};
</script>